import { Company } from "../store/ducks/companies.ducks"
import { useIntl } from "react-intl"
import { colors } from "../styles/design.config"
import styled from "styled-components/macro"
import * as Ct from "ldlj"
import { FormattedKPI } from "../routes/office/fiduciary/Indicators"
import { ReactComponent as HeartFilled } from "../assets/heart-filled.svg"
import { ReactComponent as HeartEmpty } from "../assets/heart-empty.svg"
import { croppedEndString } from "../utils/string"
import ReactTooltip from "react-tooltip"

export const FileRow = ({
  company,
  companyKPIs,
}: {
  company: Company
  companyKPIs: FormattedKPI
}) => {
  const intl = useIntl()

  return (
    <CardWithMargin key={company?.id} width={"auto"}>
      <ContentRow>
        <WrapperCompanyName data-tip={company?.name}>
          <Ct.Text
            text={croppedEndString(company?.name, 20)}
            textStyle={{
              fontFamily: "Poppins",
              fontSize: 2,
              textTransform: "uppercase",
            }}
          />
          {company.is_favorite ? <HeartFilled /> : <HeartEmpty />}

          <ReactTooltip
            delayShow={300}
            effect={"solid"}
            eventOff="mouseleave scroll mousewheel blur"
          />
        </WrapperCompanyName>
        <Ct.Text
          text={company.accounting_software_reference || ""}
          textStyle={{
            color: "cornflower",
            fontSize: 1.5,
            fontWeight: 600,
          }}
        />
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.deposit",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure color={colors.shamrock}>{companyKPIs?.Dépôts || 0}</Figure>
        </Ct.SelfAlignedColumn>
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.purchases",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure>{companyKPIs?.Achats || 0}</Figure>
        </Ct.SelfAlignedColumn>
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.sales",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure>{companyKPIs?.Ventes || 0}</Figure>
        </Ct.SelfAlignedColumn>
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.pending",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure color={colors.radicalRed}>
            {companyKPIs?.["En cours"] || 0}
          </Figure>
        </Ct.SelfAlignedColumn>
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.other",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure>{companyKPIs?.["Autres factures"] || 0}</Figure>
        </Ct.SelfAlignedColumn>
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.permanent",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure>{companyKPIs?.["Dossier permanent"] || 0}</Figure>
        </Ct.SelfAlignedColumn>
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.bank",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure>{companyKPIs?.Banque || 0}</Figure>
        </Ct.SelfAlignedColumn>
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.fiscal",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure>{companyKPIs?.Fiscal || 0}</Figure>
        </Ct.SelfAlignedColumn>
        <StyledVerticalSeparator />
        <Ct.SelfAlignedColumn>
          <Ct.Text
            text={intl.formatMessage({
              id: "office.fiduciary.kpis.social",
            })}
            textStyle={{ color: "slateGrey" }}
          />
          <Ct.Spacer height={1.25} />
          <Figure>{companyKPIs?.Social || 0}</Figure>
        </Ct.SelfAlignedColumn>
      </ContentRow>
    </CardWithMargin>
  )
}

interface FigureColor {
  color?: string
}

const Figure = styled.span<FigureColor>`
  font-weight: bold;
  color: ${({ color }) => (color ? color : colors.navy)};
`
const CardWithMargin = styled((props) => <Ct.Card {...props} />)`
  margin: 3rem 1.5rem;
  padding: 2.5rem 4rem;
`
const ContentRow = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const StyledVerticalSeparator = styled((props) => (
  <Ct.VerticalSeparator {...props} />
))`
  height: auto;
`
const WrapperCompanyName = styled.div`
  align-self: center;
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 25rem;
`
